import React, { useEffect, useState } from 'react';
import './toggle.scss';  // Create a separate CSS file for the styles
import { useAppDispatch, useAppSelector } from '../../../features';
import { changeUserSettings, getSettedUserSetting } from '../../../store/UserSlice';

const ToggleButton: React.FC = () => {
    
    const dispatch = useAppDispatch();

    const userSettings : any = useAppSelector(getSettedUserSetting);
    
    const [isToggled = false, setIsToggled] = useState<boolean>(false);

    const handleToggle = () => {
        setIsToggled(prevState => {
            const newState = !prevState;
            dispatch(changeUserSettings(undefined , newState ? 'auto' : 'manual'));
            return newState;
        });
    };

    useEffect( () => {
        if(userSettings.execute_charge) {
            if (userSettings.execute_charge === 'auto') setIsToggled(true)
            else setIsToggled(false)
        }
    },[userSettings])

    return (
        <div className="switch-container step-3">
            <div className='text-toggle'>
                Swap automatico de moeda? 
            </div>
            <div 
                className={`switch ${isToggled ? 'on' : 'off'}`} 
                onClick={handleToggle}
            >
                <div className="slider"></div>
            </div>
        </div>
    );
};

export default ToggleButton;